module.exports = __webpack_public_path__ + "img/114.94d1514e.jpg";